import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import LoadingState from '@/components/LoadingState';
import {
  useGetActiveRegionStatesLazyQuery,
  useGetTenantByKeyQuery,
} from '@/graphql';
import { activeRegionStatesVar, currentTenantVar } from '@/util/apollo/cache';
import { getTenantKey } from '@/runtimeConfig';

const Root = () => {
  // Resolved per render rather than at module load: runtime config is fetched
  // during startup, and a module-level constant would capture the hostname
  // fallback before config.json had a chance to override it.
  const query = useGetTenantByKeyQuery({
    variables: { key: getTenantKey() },
  });
  const [getActiveStates, { data }] = useGetActiveRegionStatesLazyQuery();

  useEffect(() => {
    if (query.data) {
      currentTenantVar(query.data.tenantByKey);
      getActiveStates({
        variables: { tenantId: query.data.tenantByKey!.id },
      });
    }

    return () => {
      currentTenantVar(null);
    };
  }, [query.data]);

  useEffect(() => {
    if (data) {
      activeRegionStatesVar(data.activeRegionState);
    }
  }, [data]);

  if (query.loading) {
    return <LoadingState text="Loading the application..." />;
  }

  if (query.error || (query.data && !query.data.tenantByKey)) {
    return <Navigate replace to="/invalid-tenant" />;
  }

  return <Outlet />;
};

export default Root;
